
import './App.css'
import {ItineraryCatalogView} from "./components/ItineraryCatalogView.tsx";
import {Route, Routes} from "react-router-dom";
import {ItineraryCatalogPDFView} from "./components/pdfs/ItineraryCatalogPDFView.tsx";

function App() {

  return (

        <Routes>
                <Route index element={<ItineraryCatalogView/>} />
                <Route path="*" element={<ItineraryCatalogView />} />
            <Route path="/pdfs/:tourOperator/:catalog" element={<ItineraryCatalogPDFView />} />
            <Route path="/pdfs/:tourOperator/:catalog/:itinerary" element={<ItineraryCatalogPDFView />} />
        </Routes>

  )
}

export default App
